import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useT } from "@/i18n";

// Public marketing badge shown on Landing / Auth / Pricing pages advertising
// the live admin-configured free trial. Pulls the actual day count from
// `/api/billing/trial-config` so we never lie about the offer — if admin
// disables auto-trial the badge disappears.
export default function FreeTrialBadge({ size = "md", className = "" }) {
  const { t } = useT();
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/billing/trial-config").then((r) => {
      if (alive) setCfg(r.data || null);
    }).catch(() => { /* badge just hides */ });
    return () => { alive = false; };
  }, []);

  if (!cfg?.enabled || !cfg?.days) return null;

  const small = size === "sm";
  return (
    <div
      data-testid="free-trial-badge"
      className={`inline-flex items-center gap-2 rounded-full font-bold uppercase tracking-wider text-white shadow-md ${
        small ? "px-3 py-1 text-[10px]" : "px-4 py-1.5 text-xs"
      } bg-gradient-to-r from-amber-500 via-orange-500 to-pink-600 ${className}`}
    >
      <Sparkles className={small ? "w-3 h-3" : "w-3.5 h-3.5"} />
      <span>{t("trial_badge", { days: cfg.days })}</span>
    </div>
  );
}
